// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar-container__u3tDH {
  width: 100%;
  height: 100%;
  padding: 16px 0;
  background-color: var(--m-sidebar-background-color);
}
.Sidebar_sidebar-container--border-right__Q7r6X {
  border-right: 1px solid var(--m-subtle);
}
.Sidebar_sidebar-container__header__EfFvN {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 5px;
  padding-left: 1.8rem;
}
.Sidebar_sidebar-container__header__mobile__plNGg {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}
.Sidebar_sidebar-container__header__mobile--close-sidebar__Vity1 {
  position: absolute;
  right: 12px;
  font-size: 20px !important;
  cursor: pointer;
  color: var(--m-icon-color);
}
.Sidebar_sidebar-container__header--reset-justify__Hxig1 {
  padding-left: 1.5rem;
}
.Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz {
  width: 32px;
  height: 30px;
  font-size: 0.875rem;
  color: #677788;
  border: 1px solid var(--m-subtle);
  transition: 0.4s;
  position: absolute;
  right: -16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 8px;
  background-color: #fff;
}
.Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz svg {
  font-size: 16px;
  color: var(--m-text-muted);
}
.Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz:hover svg {
  color: var(--m-text);
}
.Sidebar_sidebar-container__content__SkFsB {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.Sidebar_sidebar-container__content__SkFsB::-webkit-scrollbar-thumb {
  background-color: var(--m-scrollbar-color);
}
.Sidebar_sidebar-container__u3tDH:hover .Sidebar_sidebar-container__content__SkFsB::-webkit-scrollbar-thumb {
  background-color: var(--m-scrollbar-color-hovered);
}

[m-data-theme=dark] .Sidebar_sidebar-container--border-right__Q7r6X {
  border-right: 1px solid transparent;
}
[m-data-theme=dark] .Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz {
  background-color: var(--m-subtle-card-background-color);
  border-color: transparent;
}
[m-data-theme=dark] .Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz svg {
  color: rgba(255, 255, 255, 0.6);
}
[m-data-theme=dark] .Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz:hover svg {
  color: #fff;
}

[m-data-sidebar-theme=dark] .Sidebar_sidebar-container__u3tDH {
  background-color: #293042;
}
[m-data-sidebar-theme=dark] .Sidebar_sidebar-container--border-right__Q7r6X {
  border-right: 1px solid transparent;
}
[m-data-sidebar-theme=dark] .Sidebar_sidebar-container__content__SkFsB::-webkit-scrollbar-thumb {
  background-color: transparent;
}
[m-data-sidebar-theme=dark] .Sidebar_sidebar-container__u3tDH:hover .Sidebar_sidebar-container__content__SkFsB::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.1490196078);
}

@media (max-width: 992px) {
  .Sidebar_sidebar-container__header__EfFvN .Sidebar_menu-icon__JHuzz {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/Sidebar/Sidebar.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,mDAAA;AACF;AACE;EACE,uCAAA;AACJ;AAEE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,oBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;AAAN;AAEM;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,0BAAA;AAAR;AAII;EACE,oBAAA;AAFN;AAKI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAHN;AAKM;EACE,eAAA;EACA,0BAAA;AAHR;AAOQ;EACE,oBAAA;AALV;AAWE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AATJ;AAWI;EACE,0CAAA;AATN;AAeM;EACE,kDAAA;AAbR;;AAqBI;EACE,mCAAA;AAlBN;AAsBM;EACE,uDAAA;EACA,yBAAA;AApBR;AAsBQ;EACE,+BAAA;AApBV;AAwBU;EACE,WAAA;AAtBZ;;AA+BE;EACE,yBAAA;AA5BJ;AA8BI;EACE,mCAAA;AA5BN;AAgCM;EACE,6BAAA;AA9BR;AAoCQ;EACE,mDAAA;AAlCV;;AAyCA;EAGM;IACE,aAAA;EAxCN;AACF","sourcesContent":[".sidebar-container {\n  width: 100%;\n  height: 100%;\n  padding: 16px 0;\n  background-color: var(--m-sidebar-background-color);\n\n  &--border-right {\n    border-right: 1px solid var(--m-subtle);\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 5px;\n    padding-left: 1.8rem;\n\n    &__mobile {\n      position: relative;\n      width: 100%;\n      display: flex;\n      align-items: center;\n\n      &--close-sidebar {\n        position: absolute;\n        right: 12px;\n        font-size: 20px !important;\n        cursor: pointer;\n        color: var(--m-icon-color);\n      }\n    }\n\n    &--reset-justify {\n      padding-left: 1.5rem;\n    }\n\n    .menu-icon {\n      width: 32px;\n      height: 30px;\n      font-size: 0.875rem;\n      color: #677788;\n      border: 1px solid var(--m-subtle);\n      transition: 0.4s;\n      position: absolute;\n      right: -16px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      border-radius: 8px;\n      background-color: #fff;\n\n      svg {\n        font-size: 16px;\n        color: var(--m-text-muted);\n      }\n\n      &:hover {\n        svg {\n          color: var(--m-text);\n        }\n      }\n    }\n  }\n\n  &__content {\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n\n    &::-webkit-scrollbar-thumb {\n      background-color: var(--m-scrollbar-color);\n    }\n  }\n\n  &:hover {\n    .sidebar-container__content {\n      &::-webkit-scrollbar-thumb {\n        background-color: var(--m-scrollbar-color-hovered);\n      }\n    }\n  }\n}\n\n[m-data-theme=\"dark\"] {\n  .sidebar-container {\n    &--border-right {\n      border-right: 1px solid transparent;\n    }\n\n    &__header {\n      .menu-icon {\n        background-color: var(--m-subtle-card-background-color);\n        border-color: transparent;\n\n        svg {\n          color: rgba($color: #fff, $alpha: 0.6);\n        }\n\n        &:hover {\n          svg {\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n}\n\n[m-data-sidebar-theme=\"dark\"] {\n  .sidebar-container {\n    background-color: #293042;\n\n    &--border-right {\n      border-right: 1px solid transparent;\n    }\n\n    &__content {\n      &::-webkit-scrollbar-thumb {\n        background-color: transparent;\n      }\n    }\n\n    &:hover {\n      .sidebar-container__content {\n        &::-webkit-scrollbar-thumb {\n          background-color: #ffffff26;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  .sidebar-container {\n    &__header {\n      .menu-icon {\n        display: none;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar-container": `Sidebar_sidebar-container__u3tDH`,
	"sidebar-container--border-right": `Sidebar_sidebar-container--border-right__Q7r6X`,
	"sidebar-container__header": `Sidebar_sidebar-container__header__EfFvN`,
	"sidebar-container__header__mobile": `Sidebar_sidebar-container__header__mobile__plNGg`,
	"sidebar-container__header__mobile--close-sidebar": `Sidebar_sidebar-container__header__mobile--close-sidebar__Vity1`,
	"sidebar-container__header--reset-justify": `Sidebar_sidebar-container__header--reset-justify__Hxig1`,
	"menu-icon": `Sidebar_menu-icon__JHuzz`,
	"sidebar-container__content": `Sidebar_sidebar-container__content__SkFsB`
};
export default ___CSS_LOADER_EXPORT___;
